/**
 * Group 도메인 Zod 스키마
 */
import { GROUP_TYPE } from '../constants.js';
import { idSchema } from './common.js';
import { z } from 'zod';
const groupTypeSchema = z.enum([GROUP_TYPE.GRADE, GROUP_TYPE.DEPARTMENT]);
/**
 * 그룹 ID 입력 스키마
 */
export const getGroupInputSchema = z.object({
    id: idSchema,
});
/**
 * 그룹 목록 조회 입력 스키마
 */
export const listGroupsInputSchema = z.object({
    type: groupTypeSchema.optional(),
});
/**
 * 그룹 생성 입력 스키마
 */
export const createGroupInputSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    type: groupTypeSchema.default(GROUP_TYPE.GRADE),
});
/**
 * 그룹 수정 입력 스키마
 */
export const updateGroupInputSchema = z.object({
    id: idSchema,
    name: z.string().min(1, 'Name is required'),
    type: groupTypeSchema.optional(),
});
/**
 * 그룹 학생 추가 입력 스키마
 */
export const addStudentToGroupInputSchema = z.object({
    groupId: idSchema,
    studentId: idSchema,
});
/**
 * 그룹 학생 제거 입력 스키마
 */
export const removeStudentFromGroupInputSchema = z.object({
    groupId: idSchema,
    studentId: idSchema,
});
/**
 * 그룹 학생 일괄 추가 입력 스키마
 */
export const bulkAddStudentsToGroupInputSchema = z.object({
    groupId: idSchema,
    studentIds: z.array(idSchema).min(1, 'At least one student id is required'),
});
/**
 * 그룹 학생 일괄 제거 입력 스키마
 */
export const bulkRemoveStudentsFromGroupInputSchema = z.object({
    groupId: idSchema,
    studentIds: z.array(idSchema).min(1, 'At least one student id is required'),
});
/**
 * 그룹 삭제 입력 스키마
 */
export const deleteGroupInputSchema = z.object({
    id: idSchema,
});
/**
 * 그룹 일괄 삭제 입력 스키마 (로드맵 1단계)
 */
export const bulkDeleteGroupsInputSchema = z.object({
    ids: z.array(idSchema).min(1, 'At least one group id is required'),
});
/**
 * 그룹 출석 조회 입력 스키마
 */
export const getGroupAttendanceInputSchema = z.object({
    groupId: idSchema,
    year: z.number().int().positive().optional(),
});
